import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

// Semantic breadcrumb trail. items: [{label, to}], last item is current (no link).
export const Breadcrumbs = ({ items = [] }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumbs">
    <ol className="flex flex-wrap items-center gap-1.5 text-sm text-slatey">
      <li>
        <Link
          to="/"
          className="flex items-center gap-1 hover:text-gold transition-colors"
          data-testid="breadcrumb-home"
        >
          <Home size={14} strokeWidth={1.75} />
          <span className="sr-only">Home</span>
        </Link>
      </li>
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <li key={i} className="flex items-center gap-1.5">
            <ChevronRight size={14} className="text-stone-line" />
            {isLast || !item.to ? (
              <span className="font-medium text-charcoal" aria-current="page">
                {item.label}
              </span>
            ) : (
              <Link to={item.to} className="hover:text-gold transition-colors">
                {item.label}
              </Link>
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);

export default Breadcrumbs;
